import { IS_NOT_FOUND_UPDATED } from '@gig/magic-messages';

class PageNotFoundService {
  constructor() {
    this.isNotFound = false;
    this.registerEvents();
    this.subscribeToEvents();
    this.initializeValues();
  }
  registerEvents() {
    window.eventBus.register(IS_NOT_FOUND_UPDATED, {
      type: "boolean"
    });
  }
  subscribeToEvents() {
    window.eventBus.subscribe(IS_NOT_FOUND_UPDATED, (e) => {
      var _a;
      this.isNotFound = (_a = e.payload) != null ? _a : false;
    }, { replay: true });
  }
  initializeValues() {
    window.eventBus.publish(IS_NOT_FOUND_UPDATED, false);
  }
}

export { PageNotFoundService };
